const o = "styles-module__confirmModalWrapper___CNVFJ", l = "styles-module__confirmModal___64wHJ", r = "styles-module__confirmModalHeader___asYg3", e = "styles-module__confirmModalTitle___tFc27", _ = "styles-module__confirmModalDescription___31SGt", c = "styles-module__confirmModalFooter___EUQOQ", d = {
  confirmModalWrapper: o,
  confirmModal: l,
  confirmModalHeader: r,
  confirmModalTitle: e,
  confirmModalDescription: _,
  confirmModalFooter: c
};
export {
  l as confirmModal,
  _ as confirmModalDescription,
  c as confirmModalFooter,
  r as confirmModalHeader,
  e as confirmModalTitle,
  o as confirmModalWrapper,
  d as default
};
